/** @format */

import MuiCheckbox, { type CheckboxProps } from '@mui/material/Checkbox';

type CheckboxComponentProps = Omit<CheckboxProps, 'color'> & {
  color?: CheckboxProps['color'];
};

export const Checkbox = ({
  checked = false,
  onChange = () => {},
  className = '',
  color = 'secondary',
  ...rest
}: CheckboxComponentProps) => {
  return <MuiCheckbox checked={checked} onChange={onChange} className={className} color={color} {...rest} />;
};
